import {BehaviorSubject} from 'rxjs';
import {defaultSiteByHost} from '@/helper/localized-site';
import {chatShow$} from '@/streams/cs-robot';
import type {CsRobotInfo} from '@/streams/cs-robot';

declare global {
  interface Window {
    zE: any;
    zESettings: any;
  }
}
interface ConversationField {
  id: string;
  value: string | number | boolean;
}

const ExpandInfoMap = {
  IpConfig: changeIpConfig,
};

const conversationFields$ = new BehaviorSubject<Map<string, ConversationField>>(new Map());

export const zeUtil = {
  init(lang = 'en', onload = null, robotInfo: CsRobotInfo = null) {
    if (window.zE || !robotInfo) {
      return;
    }
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = '//static.zdassets.com/ekr/snippet.js?key=' + robotInfo.widget;
    script.defer = true;
    script.type = 'text/javascript';
    script.onload = function () {
      handleZendeskState();
      window.zE('messenger', 'hide');
      window.zE('messenger:on', 'close', function () {
        window.zE('messenger', 'hide');
        setTimeout(() => {
          chatShow$.next(false);
        }, 100);
      });
      window.zE('messenger:on', 'open', function () {
        console.log(`You have opened the messaging Web Widget`);
        window.zE('messenger', 'show');
        setTimeout(() => {
          chatShow$.next(true);
        }, 100);
      });
      onload();
      setLocale(lang);
    };
    document.head.appendChild(script);
    window.zESettings = {
      webWidget: {
        offset: {},
        chat: {
          connectOnPageLoad: false,
          prechatForm: {},
        },
      },
    };
    document.head.appendChild(script);
  },
  changeUserInfo(userInfo, tags) {
    if (userInfo.userId > 0) {
      setLocale(userInfo.lang);

      window.zE('messenger:set', 'conversationFields', {
        name: userInfo.nickName,
        email: userInfo.email,
      });
      window.zE('messenger:set', 'conversationTags', [...tags, getWebsite()]);
      return;
    }
    window.zE('messenger:set', 'conversationTags', [getWebsite()]);
  },
  async openChat() {
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  },
  async hideChat() {
    window.zE('messenger', 'close');
  },
  changeExpandInfo(type, info, csRobotInfo: CsRobotInfo) {
    if (ExpandInfoMap.hasOwnProperty(type)) {
      ExpandInfoMap[type](info, csRobotInfo);
    }
  },
};

function changeIpConfig(info, csRobotInfo: CsRobotInfo) {
  if (info?.countryCode) {
    const conversationFields = conversationFields$.getValue();
    conversationFields.set(csRobotInfo.countryCodeFieldId, {
      id: csRobotInfo.countryCodeFieldId,
      value: info.countryCode,
    });
    window.zE('messenger:set', 'conversationFields', Array.from(conversationFields.values()));
    conversationFields$.next(conversationFields);
  }
}

function setLocale(lang) {
  if (lang) {
    window.zE('messenger:set', 'locale', lang);
  }
}

function getWebsite() {
  return 'website_' + (defaultSiteByHost || 'global').toLowerCase();
}

const SESSION_KEY = 'create_zendesk_time';

function handleZendeskState() {
  const time = sessionStorage.getItem(SESSION_KEY);
  if (time) {
    return;
  }
  window.zE('messenger', 'logoutUser');
  sessionStorage.setItem(SESSION_KEY, `${new Date().valueOf()}`);
}
